export const terminologyMap: Record<
  number,
  {
    en: { singular: string; plural: string; genitive: string };
    de: { singular: string; plural: string; genitive: string };
  }
> = {
  0: {
    en: {
      singular: "Entity",
      plural: "Entities",
      genitive: "Entity",
    },
    de: {
      singular: "Einheit",
      plural: "Einheiten",
      genitive: "Einheits",
    },
  },
  1: {
    en: {
      singular: "Powerplant",
      plural: "Powerplants",
      genitive: "Powerplant",
    },
    de: {
      singular: "Kraftwerk",
      plural: "Kraftwerke",
      genitive: "Kraftwerks",
    },
  },
  2: {
    en: {
      singular: "Company",
      plural: "Companies",
      genitive: "Company",
    },
    de: {
      singular: "Unternehmen",
      plural: "Unternehmen",
      genitive: "Unternehmens",
    },
  },
  3: {
    en: {
      singular: "Product",
      plural: "Products",
      genitive: "Product",
    },
    de: {
      singular: "Produkt",
      plural: "Produkte",
      genitive: "Produkts",
    },
  },
  4: {
    en: {
      singular: "Device",
      plural: "Devices",
      genitive: "Device",
    },
    de: {
      singular: "Gerät",
      plural: "Geräte",
      genitive: "Geräts",
    },
  },
  5: {
    en: {
      singular: "Project",
      plural: "Projects",
      genitive: "Project",
    },
    de: {
      singular: "Projekt",
      plural: "Projekte",
      genitive: "Projekts",
    },
  },
};
